
import { computed, defineComponent, ref } from "vue";
import { useStore } from "@/store";
import AgCard from "@/components/ag-card/index.vue";
import AuditViewer from "@/helpers/pages/AuditViewer";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";
import moment from "moment";
const store = useStore();
import EventBus from "@/helpers/EventBus";
import dateOptions from "@/helpers/DateOptions";

export default defineComponent({
  name: "AuditViewer",
  components: { AgCard },
  data() {
    return {
      dateOptions: dateOptions,
    };
  },
  setup() {
    let module = ref(AuditViewer);
    // const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    let filter: any = ref({
      page: 1,
      limit: 5,
      startDate: moment()
        .utc()  
        .startOf("day")
        .subtract(7, "days")
        .format("YYYY-MM-DDTHH:mm:ss.SSS"),
      endDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSS"),
    });
    const getList = (
      filters: any = filter.value,
      options: any = module.value.component.options
    ) => {
      const body = { filters, options };
      if (!body.filters.startDate) {
        body.filters.startDate = moment()
          .utc()
          .startOf("day")
          .subtract(7, "days")
          .format("YYYY-MM-DDTHH:mm:ss.SSS")
      }
      if (!body.filters.endDate) {
        body.filters.endDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
      }
      delete filters.range;
      store.dispatch(GeneralActionTypes.GET_AUDITS, body);
    };
    const searchWithFilters = (param: any) => {
      filter.value.endDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
      filter.value.startDate = moment().utc()
        .startOf("day")
        .subtract(7, "days")
        .format("YYYY-MM-DDTHH:mm:ss.SSS");

      if (!param) {
        const findDate: any = module.value.filter.filters.find(
          (f) => f.param == "range"
        );
        if (findDate && findDate.vmodel) {
          if (typeof findDate.vmodel === "object" && findDate.vmodel.start && findDate.vmodel.end) {
            filter.value.endDate = moment(findDate.vmodel.end).utc().startOf("day").format(
              "YYYY-MM-DDTHH:mm:ss.SSS"
            );
            filter.value.startDate = moment(findDate.vmodel.start).utc().startOf("day").format(
              "YYYY-MM-DDTHH:mm:ss.SSS"
            );
          } else {
            filter.value.startDate = findDate.vmodel;
          }
        }
      }
      const filters = filter.value;
      delete filters.computer;
      const options = module.value.component.options;
      options.page = 1;
      getList(filters, options);
    };
    const resetFilters = () => {
      module.value.filter.filters.forEach((item: any) => {
        if (item.param == "range") {
          item.vmodel = dateOptions[0].value;
          item.selectedLabel = dateOptions[0].label;
        } else {
          item.vmodel = null;
        }
      });
      searchWithFilters(true);
    };
    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
    };
  },
  mounted() {
    EventBus.on("AuditViewerLoad", (data: any) => {
      this.loadFilters(data);
      const filters = this.filter;
      const options = this.module.component.options;
      this.getList(filters, options);
    });
    let data: any = this.$route.params.data;
    if (data) {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, true);
      return;
    }
    this.setFilterStatus();
    const filters = this.filter;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  methods: {
    loadFilters(data: any) {
      this.module.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      if (data != undefined) {
        data = JSON.parse(data);
        data.forEach((item: any) => {
          this.filter[item.name] = item.value;
          this.module.filter.filters.forEach((filter) => {
            if (filter.apiEquivalent === "range" && item.name === "range") {
              if (!filter.vmodel) {
                this.filter["startDate"] = moment(item.value.vmodel.start)
                  .utc()
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS");
                this.filter["endDate"] = moment(item.value.vmodel.end)
                  .utc()
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS");
              } else {
                this.filter["startDate"] = moment()
                  .utc()
                  .add(-7, "days")
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS");
                this.filter["endDate"] = moment().utc().format(
                  "YYYY-MM-DDTHH:mm:ss.SSS"
                );
              }

              if (this.filter.range) {
                this.module.filter.filters[0] = this.filter.range;
              }
              return;
            }
            if (filter.apiEquivalent == item.name) {
              filter.vmodel = item.value;
              return;
            }
          });
        });
      }
    },
  },
});
